import { OrderList } from "./components/OrderList";
import { useOrdersData } from "./useOrdersData";

export const OrdersPage = () => {
  const { orders, loading, error, reload } = useOrdersData();

  return (
    <OrderList orders={orders} loading={loading} error={error} onOrderDeleted={reload} />
  );
};
